// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"ea94f3ba","455":"126e7fd3","551":"a0730a0f","842":"53d050e2","977":"f588de64"}[chunkId] + ".chunk.js";
};